import { AxiosResponse } from 'axios';
import { checkNZUser, isUserFromAustralia } from 'src/lib/utils';
import paymentAPI from 'src/pages/deprecated/payment/api';
import { ShippingAddressFormValues } from 'src/pages/payment-new/components/address-fields/types';
import { ChallengeSelectionPreviewResponse } from 'src/pages/types';

type Params = {
  isNZUser?: boolean;
  isChallengePackage?: boolean;
  currency?: string;
};

export const stripeProductsApi = async (
  params?: Params
): Promise<AxiosResponse> => {
  const {
    isNZUser = checkNZUser(),
    currency,
    isChallengePackage,
  } = params ?? {};

  let currencyParam = isNZUser ? 'nzd' : 'aud';
  if (currency) {
    currencyParam = currency;
  }
  const queryParams = new URLSearchParams();

  if (isChallengePackage) {
    queryParams.set('challenge', 'true');
  }
  const query = queryParams.toString() ? `?${queryParams}` : '';

  const url = `stripe/products/${currencyParam}${query}`;

  try {
    return await paymentAPI.get(url);
  } catch (error) {
    console.error('Error fetching stripe products', error);
    return Promise.reject(error);
  }
};

export const saveShippingAddress = async (
  data: ShippingAddressFormValues,
  proteinFlavour?: string,
  isSistemaGiftActive?: boolean
): Promise<AxiosResponse | void> => {
  try {
    if (!proteinFlavour && !isSistemaGiftActive) {
      throw new Error('Protein flavour is required');
    }

    const payload = {
      address: data?.streetAddress?.trim(),
      country: data?.country?.trim(),
      state: data?.stateProvince?.trim(),
      postal: data?.postalCode?.trim(),
      city: data?.suburbCity?.trim(),
      phone: data?.mobilePhone?.trim(),
      protein_flavour: proteinFlavour || null,
    };

    const hasAtLeastOneValue = Object.values(payload).some(value => !!value);

    if (!hasAtLeastOneValue) {
      return;
    }

    return await paymentAPI.put('/user/update-client-detail', payload);
  } catch (error) {
    console.error('Could not save shipping address', error);
    return Promise.reject(error);
  }
};

export const getShopifyVariantList = async (): Promise<AxiosResponse> => {
  const isAus = isUserFromAustralia();

  try {
    return await paymentAPI.get('/shopify-variant-list', {
      params: isAus ? { country: 'Australia' } : undefined,
    });
  } catch (error) {
    console.error('Error fetching shopify variants', error);
    return Promise.reject(error);
  }
};

export const getChallengeSelectionPreview = async (
  currency?: string
): Promise<AxiosResponse<ChallengeSelectionPreviewResponse>> => {
  const isNZUser = checkNZUser();
  let currencyParam = isNZUser ? 'nzd' : 'aud';
  if (currency) {
    currencyParam = currency;
  }

  try {
    return await paymentAPI.get(`/stripe/challenge/selection-preview`, {
      params: { currency: currencyParam },
    });
  } catch (error) {
    console.error('Error fetching challenge selection preview', error);
    return Promise.reject(error);
  }
};
